export const scrollElementIntoView = (
  element: HTMLElement,
  options: ScrollIntoViewOptions,
  offset?: {
    top?: number;
  },
) => {
  if (!offset) {
    element.scrollIntoView(options);
  }

  if (offset?.top) {
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementPosition = element?.getBoundingClientRect()?.top;
    const offsetPosition = elementPosition - bodyRect - offset.top;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }

  return new Promise<{ isInView: true }>((resolve, _reject) => {
    const intersectionObserver = new IntersectionObserver(entries => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        intersectionObserver.unobserve(element);
        return resolve({ isInView: true });
      }

      return { isInView: false };
    });

    intersectionObserver.observe(element);
  });
};
